import { useInfiniteQuery } from "@tanstack/react-query";
import {
  XeroChartOfAccountsListParametersType,
  XeroChartOfAccountsListResponseType,
} from "@sellar-io/api-v2/types";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useXeroChartOfAccountsList = <
  TData = XeroChartOfAccountsListResponseType,
>(
  params: XeroChartOfAccountsListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    staleTime: 1000 * 60 * 10,
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.XeroChartOfAccounts,
      params,
    ],
    queryFn: ({ pageParam }) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `xero/chart-of-accounts`,
        params: {
          ...params,
          offset: pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options, limit: params.limit },
    }),
  });
};
